<ng-container *transloco="let t">
  @if (minified) {
    <div>
      @for (worksite of company.worksites; track worksite) {
        <div>
          @if (worksite.identicalWorksites.length === 0) {
            <div class="row align-items-center border-bottom m-0 py-2">
              <div class="col-4 p-0">
                <strong>{{ worksite.name }}</strong>
              </div>
              <div class="col-6 p-0">
                {{ worksite.address | comma }}
                {{ worksite.city | titlecase }}
              </div>
              @if (
                !(extendedWorksites$ | async).includes(worksite.providerId)
              ) {
                <div class="col-1 p-0">
                  <button
                    vinnova-button-text
                    type="button"
                    (click)="onSelectWorksite($event, worksite)"
                    [disabled]="
                      alreadySelectedWorksites.includes(worksite.providerId) ||
                      isSelecting()
                    "
                  >
                    @if (isSelecting() !== worksite.providerId) {
                      <span>
                        @if (isWorksiteConflict(worksite.providerId)) {
                          <span>
                            {{ t('worksite_conflict') }}
                          </span>
                        }
                        @if (isWorksiteAlreadySelected(worksite.providerId)) {
                          <span>
                            {{ t('worksite_already_selected') }}
                          </span>
                        }
                        @if (
                          !isFinancierSearch ||
                          !alreadySelectedWorksites.includes(
                            worksite.providerId
                          )
                        ) {
                          <span>
                            {{
                              alreadySelectedWorksites.includes(
                                worksite.providerId
                              )
                                ? t('worksite_already_selected')
                                : t('worksite_select')
                            }}
                          </span>
                        }
                        <span class="visually-hidden">{{ worksite.name }}</span>
                      </span>
                    }
                    @if (isSelecting() === worksite.providerId) {
                      <div class="loader btn-loader"></div>
                    }
                  </button>
                </div>
              }
            </div>
          } @else {
            <div class="row align-items-center">
              <div class="col p-0">
                <strong>{{ worksite.name }}</strong>
              </div>
              <div class="col-3 p-0">
                @if (
                  !(extendedWorksites$ | async).includes(worksite.providerId)
                ) {
                  <button
                    vinnova-button-text
                    type="button"
                    class="d-block ms-auto"
                    (click)="
                      onShowExtendedWorksites(
                        worksite,
                        company.providerId,
                        $event.target
                      )
                    "
                  >
                    {{ t('worksite_show_more') }}
                  </button>
                }
              </div>
              <div class="col-1 p-0" style="display: none">
                <div class="loader my-2 mx-auto"></div>
              </div>
            </div>
            @if ((extendedWorksites$ | async).includes(worksite.providerId)) {
              <div>
                @for (
                  identicalWorksite of worksite.identicalWorksites;
                  track identicalWorksite
                ) {
                  <div
                    class="row align-items-center m-0 border-bottom"
                    style="min-height: 3rem"
                  >
                    <div class="col-4 p-0">
                      <strong>{{
                        identicalWorksite.department
                          ? identicalWorksite.department
                          : worksite.name
                      }}</strong>
                    </div>
                    <div class="col-6 pe-1">
                      {{ identicalWorksite.address | comma }}
                      {{ identicalWorksite.city | titlecase }}
                    </div>
                    <div class="col-1 p-0">
                      <button
                        vinnova-button-text
                        type="button"
                        (click)="onSelectWorksite($event, identicalWorksite)"
                        [disabled]="
                          alreadySelectedWorksites.includes(
                            identicalWorksite.providerId
                          ) || isSelecting()
                        "
                      >
                        @if (isSelecting() !== identicalWorksite.providerId) {
                          <span>
                            @if (
                              isWorksiteConflict(identicalWorksite.providerId)
                            ) {
                              <span>
                                {{ t('worksite_conflict') }}
                              </span>
                            }
                            @if (
                              isWorksiteAlreadySelected(
                                identicalWorksite.providerId
                              )
                            ) {
                              <span>
                                {{ t('worksite_already_selected') }}
                              </span>
                            }
                            @if (
                              !isFinancierSearch ||
                              !alreadySelectedWorksites.includes(
                                identicalWorksite.providerId
                              )
                            ) {
                              <span>
                                {{
                                  alreadySelectedWorksites.includes(
                                    identicalWorksite.providerId
                                  )
                                    ? t('worksite_already_selected')
                                    : t('worksite_select')
                                }}
                              </span>
                            }
                            <span class="visually-hidden">{{
                              worksite.name
                            }}</span>
                          </span>
                        }
                        @if (isSelecting() === identicalWorksite.providerId) {
                          <div class="loader btn-loader"></div>
                        }
                      </button>
                    </div>
                  </div>
                }
              </div>
            }
          }
        </div>
      }
      <div class="row py-2">
        <div class="col-12 p-0">
          <button
            vinnova-button-text
            type="button"
            (click)="onCreateWorksite($event)"
          >
            <small>{{ t('worksite_btn_add_new_worksite') }}</small>
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Template -->
  <ng-template #showAllWorksitesLink>
    @if (showAllWorksitesParameter$ | async) {
      <button
        vinnova-button-text
        type="button"
        (click)="onShowAllWorksites($event)"
        style="padding-left: 0.7rem"
      >
        <small>{{ t('worksite_show_all_worksites') }}</small>
      </button>
    }
  </ng-template>

  @if (!minified) {
    <div>
      <!-- Organisation Header -->
      <div
        class="panel panel-default"
        [ngClass]="(isCollapsedParameter$ | async) ? 'closed' : 'open'"
      >
        <button
          vinnova-button-text
          type="button"
          (click)="onCollapse()"
          class="panel-heading text-black d-block px-0 w-100"
        >
          <div class="d-flex align-items-center border-bottom pt-2 pb-3">
            @if (isCollapsedParameter$ | async) {
              <lib-icon name="plus"></lib-icon>
            } @else {
              <lib-icon name="minus"></lib-icon>
            }
            <strong class="ps-3">{{ company.name }}</strong>
          </div>
        </button>
        <!-- Loader -->
        @if (isLoading) {
          <div class="loader my-2 mx-auto"></div>
        } @else {
          <!-- Worksites -->
          <div [libCollapse]="isCollapsedParameter$ | async">
            @for (worksite of company.worksites; track worksite) {
              <div>
                @if (worksite.identicalWorksites.length === 0) {
                  <div class="row align-items-center border-bottom m-0">
                    <div class="col-md-5 col-sm-10 order-sm-1">
                      <strong>{{ worksite.name }}</strong>
                    </div>
                    <div class="col-md-3 col-sm-12 order-sm-2">
                      {{ worksite.address | comma }}
                      {{ worksite.city | titlecase }}
                    </div>
                    <div
                      class="col-md-2 col-sm-12 order-sm-2 d-flex justify-content-center"
                    >
                      {{ worksite.country }}
                    </div>
                    <div
                      class="col-md-2 col-sm-2 order-sm-1 order-md-2 lastColumn"
                    >
                      @if (
                        isSelecting() === worksite.providerId &&
                        (unavailableWorksites$ | async).includes(
                          worksite.providerId
                        )
                      ) {
                        <div class="invalid-feedback">
                          <div>
                            <lib-icon
                              name="alert-circle"
                              aria-hidden="true"
                              size="small"
                            />
                          </div>
                          <div
                            [ngClass]="getActiveLang() === 'sv' ? 'nowrap' : ''"
                          >
                            {{ t('worksite_cannot_be_selected') }}
                          </div>
                        </div>
                      }
                      @if (
                        !(unavailableWorksites$ | async).includes(
                          worksite.providerId
                        ) &&
                          (company.bisnodeStatus.code | isValidBisnodeStatus);
                        as result
                      ) {
                        <button
                          vinnova-button-text
                          type="button"
                          [disabled]="
                            alreadySelectedWorksites.includes(
                              worksite.providerId
                            ) || isSelecting()
                          "
                          (click)="onSelectWorksite($event, worksite)"
                        >
                          @if (isSelecting() !== worksite.providerId) {
                            <span>
                              @if (isWorksiteConflict(worksite.providerId)) {
                                <span>
                                  {{ t('worksite_conflict') }}
                                </span>
                              }
                              @if (
                                isWorksiteAlreadySelected(worksite.providerId)
                              ) {
                                <span>
                                  {{ t('worksite_already_selected') }}
                                </span>
                              }
                              @if (
                                !isFinancierSearch ||
                                !alreadySelectedWorksites.includes(
                                  worksite.providerId
                                )
                              ) {
                                <span>
                                  {{
                                    alreadySelectedWorksites.includes(
                                      worksite.providerId
                                    )
                                      ? t('worksite_already_selected')
                                      : t('worksite_select')
                                  }}
                                </span>
                              }
                              <span class="visually-hidden">{{
                                worksite.name
                              }}</span>
                            </span>
                          }
                          @if (isSelecting() === worksite.providerId) {
                            <div class="loader btn-loader"></div>
                          }
                        </button>
                      }
                    </div>
                  </div>
                } @else {
                  <div
                    class="row align-items-center m-0 border-bottom"
                    style="min-height: 3rem"
                  >
                    <div class="col-md-5 col-sm-10 order-sm-1">
                      <strong>{{ worksite.name }}</strong>
                    </div>
                    <div class="col-md-3 col-sm-12 order-sm-2"></div>
                    <div
                      class="col-md-2 col-sm-12 order-sm-2 d-flex justify-content-center"
                    >
                      {{ worksite.country }}
                    </div>
                    <div
                      class="col-md-2 col-sm-2 order-sm-1 order-md-2 nowrap lastColumn"
                    >
                      @if (
                        !(extendedWorksites$ | async).includes(
                          worksite.providerId
                        )
                      ) {
                        <button
                          vinnova-button-text
                          type="button"
                          (click)="
                            onShowExtendedWorksites(
                              worksite,
                              company.providerId,
                              $event.target
                            )
                          "
                        >
                          {{ t('worksite_show_more') }}
                        </button>
                      }
                    </div>
                    <div
                      class="col-md-1 col-sm-12 order-sm-3 p-0"
                      style="display: none"
                    >
                      <div class="loader my-2 mx-auto"></div>
                    </div>
                  </div>
                  <div
                    class="test"
                    [libCollapse]="
                      !(extendedWorksites$ | async).includes(
                        worksite.providerId
                      )
                    "
                    #extendedAccordion="lib-collapse"
                  >
                    <div class="panel panel-default">
                      @for (
                        identicalWorksite of worksite.identicalWorksites;
                        track identicalWorksite
                      ) {
                        <div
                          class="row align-items-center m-0 border-bottom"
                          style="min-height: 3rem"
                        >
                          <div class="col-md-1 col-sm-12 order-sm-1"></div>
                          <div class="col-md-4 col-sm-10 order-sm-1">
                            <strong>{{
                              identicalWorksite.department
                                ? identicalWorksite.department
                                : worksite.name
                            }}</strong>
                          </div>
                          <div class="col-md-4 col-sm-12 order-sm-2">
                            {{ identicalWorksite.address | comma }}
                            {{ identicalWorksite.city | titlecase }}
                          </div>
                          <div class="col-md-2 col-sm-12 order-sm-2">
                            {{ identicalWorksite.phone }}
                          </div>
                          <div
                            class="col-md-1 col-sm-2 order-sm-1 order-md-2 d-flex justify-content-center"
                          >
                            @if (
                              company.bisnodeStatus.code | isValidBisnodeStatus;
                              as result
                            ) {
                              <button
                                vinnova-button-text
                                type="button"
                                [disabled]="
                                  alreadySelectedWorksites.includes(
                                    identicalWorksite.providerId
                                  ) || isSelecting()
                                "
                                (click)="
                                  onSelectWorksite($event, identicalWorksite)
                                "
                              >
                                @if (
                                  isSelecting() !== identicalWorksite.providerId
                                ) {
                                  <span>
                                    @if (
                                      isWorksiteConflict(
                                        identicalWorksite.providerId
                                      )
                                    ) {
                                      <span>
                                        {{ t('worksite_conflict') }}
                                      </span>
                                    }
                                    @if (
                                      isWorksiteAlreadySelected(
                                        identicalWorksite.providerId
                                      )
                                    ) {
                                      <span>
                                        {{ t('worksite_already_selected') }}
                                      </span>
                                    }
                                    @if (
                                      !isFinancierSearch ||
                                      !alreadySelectedWorksites.includes(
                                        identicalWorksite.providerId
                                      )
                                    ) {
                                      <span>
                                        {{
                                          alreadySelectedWorksites.includes(
                                            identicalWorksite.providerId
                                          )
                                            ? t('worksite_already_selected')
                                            : t('worksite_select')
                                        }}
                                      </span>
                                    }
                                    <span class="visually-hidden">{{
                                      worksite.name
                                    }}</span>
                                  </span>
                                }
                                @if (
                                  isSelecting() === identicalWorksite.providerId
                                ) {
                                  <div class="loader btn-loader"></div>
                                }
                              </button>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <div class="row">
              <div class="col-12">
                @if (
                  (showAllWorksitesParameter$ | async) === false &&
                    (company.bisnodeStatus.code | isValidBisnodeStatus);
                  as result
                ) {
                  <button
                    vinnova-button-text
                    type="button"
                    (click)="onCreateWorksite($event)"
                    style="padding-left: 0.3rem"
                  >
                    <small>{{ t('worksite_btn_add_new_worksite') }}</small>
                  </button>
                }
                <ng-container *ngTemplateOutlet="showAllWorksitesLink">
                </ng-container>
                @if (
                  !(company.bisnodeStatus.code | isValidBisnodeStatus);
                  as result
                ) {
                  <div>
                    <p class="invalid-feedback my-2">
                      <lib-icon name="alert-triangle"></lib-icon>
                      <span
                        [innerHtml]="t('worksite_organisation_not_active')"
                      ></span>
                    </p>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</ng-container>
